var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"title":_vm.$t('FINANCE.SALES_INVOICE.TITLE'),"hint":_vm.$t('HINT.FINANCE.INVOICES')}},[_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('SalesReportsInvoices'),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('SalesReportsFile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }